<!--
 * @Author: RYL
 * @Description: 选择报警终端
 * @Date: 2020-10-29 11:55:28
 * @LastEditTime: 2020-11-19 15:48:58
-->
<template>
  <div>
    <el-dropdown trigger="click" placement="bottom-start">
      <div class="terminal-input">
        <div
          v-if="terminalSelections.length <= 0"
          style="height: 28px;line-height: 28px; color: #C0C4CC;padding-left: 15px"
        >
          {{ $t("lang.alarmNotice.pleaseChoose") }}
        </div>
        <div v-else>
          <el-tag
            type="info"
            size="small"
            closable
            :key="item.id"
            @close="closeTerminal(item)"
            v-for="item in terminalSelections"
          >
            {{ item.sn }}（{{ item.name }}）
          </el-tag>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <div class="select">
          <div class="select-project">
            <el-tree
              lazy
              :highlight-current="true"
              :expand-on-click-node="false"
              @node-click="clickProject"
              :load="loadNode"
              :props="defaultProps"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <span style="font-size: 16px">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="select-devices">
            <el-tree
              :highlight-current="true"
              :data="deviceList"
              @node-click="clickDevices"
              :props="deviceProps"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="font-size: 16px"
                  >{{ node.label }}（{{
                    data.deviceName ? data.deviceName : "N/A"
                  }}）</span
                >
              </span>
            </el-tree>
          </div>
          <div class="select-terminal">
            <el-tree
              :highlight-current="true"
              :data="terminalList"
              ref="terminalTree"
              show-checkbox
              node-key="id"
              @check-change="checkTerminal"
              :props="terminalProps"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="font-size: 16px"
                  >{{ node.label }}（{{ data.name ? data.name : "N/A" }}）</span
                >
              </span>
            </el-tree>
          </div>
        </div>
        <!-- <div style="margin-top: 20px">
            <pagination
              :total="total"
              :offset="offset"
              :limit="limit"
              @SizeChanges="SizeChanges"
              @CurrentChanges="CurrentChanges">
            </pagination>
          </div>        -->
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import { PublicComponent } from "@/mixins/common";
import { getFirstGroup, getSecondGroup } from "@/api/cloudMonitor/projectGroup";
import { getListByGroup } from "@/api/cloudMonitor/deviceList";
import { getByDevice } from "@/api/cloudMonitor/terminalList";
import { cloneDeep, uniqBy, findIndex } from "lodash";
export default {
  mixins: [PublicComponent],
  props: {
    terminal: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    pagination,
  },
  data() {
    return {
      projectList: [],
      deviceList: [],
      terminalList: [],
      defaultProps: {
        chirldren: "children",
        label: "groupName",
      },
      deviceProps: {
        label: "deviceSn",
      },
      terminalProps: {
        label: "sn",
      },
      loading: false,
      terminalSelections: [],
    };
  },
  mounted() {
    this.loading = true;
  },
  watch: {
    terminal: {
      immediate: true,
      deep: true,
      handler() {
        if (this.terminal.length > 0) {
          this.terminalSelections = this.terminal;
        }
      },
    },
  },
  methods: {
    // 点击项目分组节点
    clickProject(node) {
      let params = {
        pageParam: {
          current: 1,
          size: 99999,
        },
        deviceInfo: {
          deviceGid: node.groupId,
        },
      };
      this.terminalList = [];
      getListByGroup(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.deviceList = data.records;
        }
      });
    },
    // 点击设备
    clickDevices(node) {
      // 根据设备Id查询终端
      let params = {
        pageParam: {
          current: 1,
          size: 99999,
        },
        dtuInfo: {
          did: node.deviceDid,
          alarmNotice: 1,
        },
      };
      getByDevice(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.terminalList = data.records;
          // 获取终端后设置已经选择的勾选状态
          this.terminalSelections.forEach((item) => {
            this.$nextTick(() => {
              this.$refs.terminalTree.setChecked(item, true);
            });
          });
        }
      });
    },

    // 获取一级列表
    getFirstList(node, resolve) {
      let params = {
        current: 1,
        size: 99999,
      };
      this.deviceList = [];
      getFirstGroup(params)
        .then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data;
            this.projectList = data.records;
            if (this.projectList.length > 0) {
              this.projectRadio = this.projectList[0];
            }
            resolve(data.records);
            this.total = data.total;
            this.loading = false;
          }
        })
        .catch(() => {});
    },
    // 获取二级列表
    async loadNode(node, resolve) {
      let nodeData = [];
      // 获取一级分组
      if (node.level === 0) {
        this.getFirstList(node, resolve);
      } else {
        getSecondGroup(node.data.groupId).then((res) => {
          if (res.data.code === 0) {
            resolve(res.data.data);
          }
        });
      }
    },
    // 终端列表选中节点发生变化时
    checkTerminal(data, isCheck) {
      let selections = cloneDeep(this.terminalSelections);
      if (isCheck) {
        // 被选中
        selections.push(data);
        // 去重
        this.terminalSelections = uniqBy(selections, "id");
      } else {
        // 找到且删除
        let index = findIndex(this.terminalSelections, function(item) {
          return item.id === data.id;
        });
        if (index !== -1) {
          // 找到则移除
          this.terminalSelections.splice(index, 1);
        }
      }
    },
    // 删除终端标签
    closeTerminal(tag) {
      this.$refs.terminalTree.setChecked(tag, false);
      let index = findIndex(this.terminalSelections, function(item) {
        return item.id === tag.id;
      });
      if (index !== -1) {
        // 找到则移除
        this.terminalSelections.splice(index, 1);
      }
    },
    // 获取选择的终端
    getTerminals() {
      return this.terminalSelections;
    },
  },
};
</script>
<style scoped>
.select {
  display: flex;
  width: 100%;
}
.select-project,
.select-devices,
.select-terminal {
  max-height: 400px;
  overflow: scroll;
}
.select-project {
  min-width: 150px;
  max-width: 200px;
  border-right: 1px solid #b4cee9;
}
.terminal-input {
  min-width: 4rem;
  max-width: 8rem;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  min-height: 28px;
  cursor: pointer;
}
.select-devices {
  min-width: 150px;
  max-width: 300px;
  overflow: scroll;
  border-right: 1px solid #b4cee9;
}
.select-terminal {
  min-width: 150px;
  max-width: 400px;
  overflow: scroll;
  outline: none;
}
</style>
